import React, { useState, useEffect, useMemo } from "react";
import './index.css';
import { useNavigate } from "react-router-dom";
import { useUser } from '../UserContext';
import logo from '../../imagens/Sem fundo.png';
import { Link } from "react-router-dom";

const Agenda = () => {
  const navigate = useNavigate();
  const { userInfo } = useUser();
  const [loadingClientes, setLoadingClientes] = useState(true);

  const [clientes, setClientes] = useState([]);
  const [Segunda, setSegunda] = useState(false);
  const [Terca, setTerca] = useState(false);
  const [Quarta, setQuarta] = useState(false);
  const [Quinta, setQuinta] = useState(false);
  const [Sexta, setSexta] = useState(false);
  const [ageObservacao, setAgeObsercao] = useState('');
  const [modalObservacao, setModalObservacao] = useState(false);
  const [clienteSelecionado, setClienteSelecionado] = useState(null);

  const credentials = btoa(`${userInfo.alias};${userInfo.venLogin}:${userInfo.venSenha}`);

  /*const filteredClientes = clientes.filter((c) => {
    const termo = searchTerm.toLowerCase();
    return (
      c.cliId?.toString().includes(termo) ||
      c.colNome?.toLowerCase().includes(termo) ||
      c.colFantasia?.toLowerCase().includes(termo) ||
      c.colCnpjCpf?.toLowerCase().includes(termo)
    );
  });*/

  // Redireciona se não estiver logado
  useEffect(() => {
    if (!userInfo?.username) {
      localStorage.removeItem('userInfo');
      navigate('/');
      return;
    } 
  }, [userInfo, navigate]);

  // Busca clientes e produtos
  useEffect(() => {
    const fetchTelevendas = async () => {
      try {
    const res = await fetch(`${userInfo.url}/subgrupomarca`, {
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          'Accept': 'application/json; charset=utf-8',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`,
        },
      });
      
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const text = await res.text();
      // ✅ SOLUÇÃO DO ERRO 500/JSON: Remove caracteres de controle (quebras de linha, tabs, etc)
      //const safeText = text.replace(/[\r\n\t]/g, " ").replace(/\u00A0/g, ' ').trim();
      const safeText = text.replace(/[\r\n\t]/g, " ").replace(/\u00A0/g, ' ').trim();
      const json = JSON.parse(safeText);

      setClientes(json);

      return json;
      
    } catch (err) {
      console.error('❌ Erro ao buscar dados:', err);
      return [];
    } finally {
      setLoadingClientes(false);
    }
    };

    fetchTelevendas();
  }, [userInfo, credentials]);


      const fetchTelevendas = async () => {
      try {
const res = await fetch(`${userInfo.url}/subgrupomarca`, {
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          'Accept': 'application/json; charset=utf-8',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`,
        },
      });
      
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const text = await res.text();
      // ✅ SOLUÇÃO DO ERRO 500/JSON: Remove caracteres de controle (quebras de linha, tabs, etc)
      //const safeText = text.replace(/[\r\n\t]/g, " ").replace(/\u00A0/g, ' ').trim();
      const safeText = text.replace(/[\r\n\t]/g, " ").replace(/\u00A0/g, ' ').trim();
      const json = JSON.parse(safeText);

      setClientes(json);

      return json;
      
    } catch (err) {
      console.error('❌ Erro ao buscar dados:', err);
      return [];
    } finally {
      setLoadingClientes(false);
    }
    };

    // Lógica de filtragem da tabela
    const dadosFiltradosTable = useMemo(() => {
      return clientes.filter(item => {
        const matchVendedor = userInfo.ven_id === item.venId || item.venId === null;
        const matchSegunda = !Segunda || item.segunda === "T";
        const matchTerca = !Terca || item.terca === "T";
        const matchQuarta = !Quarta || item.quarta === "T";
        const matchQuinta = !Quinta || item.quinta === "T";
        const matchSexta = !Sexta || item.sexta === "T";
  
        return matchSegunda && matchTerca && matchQuarta && matchQuinta && matchSexta && matchVendedor;
      });
    }, [clientes, Segunda, Terca, Quarta, Quinta, Sexta, userInfo.ven_id]);

  const hoje = () => {
    const data = new Date();
    
    // Extrai os componentes locais (do seu relógio)
    const ano = data.getFullYear();
    const mes = String(data.getMonth() + 1).padStart(2, '0'); // Meses começam em 0
    const dia = String(data.getDate()).padStart(2, '0');
    const hora = String(data.getHours()).padStart(2, '0');
    const minuto = String(data.getMinutes()).padStart(2, '0');
    const segundo = String(data.getSeconds()).padStart(2, '0');

    // Monta no formato padrão de banco (YYYY-MM-DD HH:mm:ss)
    return `${ano}-${mes}-${dia} ${hora}:${minuto}:${segundo}`;
  }
  
    const semPedido = async (cliId) => { 
      if (ageObservacao === '') {
        alert('É obrigatório informar a observação.');
        return;
      }

  try {
      const payload = {
      AGE_STATUS_VENDA: 'Finalizado',
      AGE_MOTIVO_VISITA: 'Sem Pedido no Dia',
      AGE_TIPO_ATENDIMENTO: 'Telefone',
      AGE_OBSERVACAO: ageObservacao,
      FUN_ID: Number(userInfo.ven_id),
      VEN_ID: Number(userInfo.ven_id),
      AGE_DTA_AGENDAMENTO: hoje,
      CLI_ID: clienteSelecionado,
    };

      console.log('🚀 Payload montado para final:', payload);
      console.log(hoje());

      // 2. O FETCH precisa de AWAIT
      const response = await fetch(`${userInfo.url}/agendamento`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`,
        },
        body: JSON.stringify(payload),
      });

      // 3. A verificação da resposta
      if (response.ok) {
        alert('Evento vinculado com sucesso!');
        setModalObservacao(false);
        fetchTelevendas();
        setAgeObsercao('');
        setClienteSelecionado(null)
        //console.log('✅ Resposta do servidor:', await response.json());
      } else {
        // Aqui também precisa de AWAIT
        const errorData = await response.text(); 
        //console.error('❌ Resposta de erro do servidor:', errorData);
        alert(`Erro do servidor: ${errorData}`);
      }
    } catch (error) {
      console.error('❌ Erro na requisição PUT:', error);
      alert('Erro ao finalizar serviço. Verifique o console.');
    }
  };

  return (
    <>
      {loadingClientes ? (
        <div className="loading-container" tabIndex={-1}>
          <img src={logo} alt="Logo" className="loading-logo" />
          <p>Carregando agenda...</p>
        </div>
      ) : (
        <>
          <header className="header">
            <img src={`${userInfo.url}/imagens/${userInfo.alias}.bmp`} alt="Logo da empresa"  className='logoHeader'></img>
            <h2>Bem-vindo, {userInfo.username}!</h2>
            {userInfo.controlaFlex === 'T' && (
                <span className={(userInfo.venFlexDisponivel ?? 0) < 0 ? 'flex-negativo' : 'flex-positivo'}>
                  <strong>Seu flex atual é de : {(userInfo.venFlexDisponivel ?? 0 ).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}</strong></span>)}
            {userInfo.descontoFinanceiro === 'T' && (
                <span className={(userInfo.venFlexDisponivel ?? 0) < 0 ? 'flex-negativo' : 'flex-positivo'}>
                  <strong>Seu flex atual é de : {(userInfo.venFlexDisponivel ?? 0 ).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}</strong></span>)}
            <h1>Televendas: {userInfo.company}</h1>
          </header>

          <div className="agenda-container">
            <Link to="/menu" className="link-style">Voltar ao menu</Link>
            <div className="agenda-header">
              <button className="btn-cadastro" onClick={() => navigate('/venda')}>
                Cadastro de Pedidos
              </button>
            </div>
          </div>

          <div className="crm-tabela">
            <div className="crm-filtros">
              <label className="filtro-item">
                <input type="checkbox" id="segunda" name="segunda" value="Segunda" onClick={() => setSegunda(!Segunda)} />
                <span>Segunda</span>
              </label>

              <label className="filtro-item">
                <input type="checkbox" id="terca" name="terca" value="Terça" onClick={() => setTerca(!Terca)}/>
                <span>Terça</span>
              </label>

              <label className="filtro-item">
                <input type="checkbox" id="quarta" name="quarta" value="Quarta" onClick={() => setQuarta(!Quarta)} /> 
                <span>Quarta</span>
              </label>

              <label className="filtro-item">
                <input type="checkbox" id="quinta" name="quinta" value="Quinta" onClick={() => setQuinta(!Quinta)} />
                <span>Quinta</span>
              </label>

              <label className="filtro-item">
                <input type="checkbox" id="sexta" name="sexta" value="Sexta" onClick={() => setSexta(!Sexta)} />
                <span>Sexta</span>
              </label>
            </div>
            <h3>Clientes</h3>
            {loadingClientes ? <p>Processando dados...</p> : (
            <table>
                <thead>
                    <tr>
                        <th>ID</th>       
                        <th>Nome</th>       
                        <th>Limite de Crédito</th>
                        <th>Credito Utilizado</th>
                        <th>Status do Cliente</th>
                        <th>Status do Financeiro</th>
                        <th>Dias sem Compra</th>
                        <th>Cliente Positivo</th>
                        <th>Marcar Sem Pedido</th>
                    </tr>
                </thead>
                <tbody> 
                    {dadosFiltradosTable.map(item => (
                        <tr key={item.cliId} className={item.vendahoje === "T" ? "vendahoje" : item.vendahoje ==="F" ? "naoVendaHoje" : "aguardando"}>
                            <td>{item.cliId}</td>
                            <td>{item.colNome}</td>
                            <td>{item.vlrCredito?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                            <td>{item.limiteUtilizado?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                            <td>{item.statusCliente}</td>
                            <td>{item.statusFinanceiro}</td>
                            <td>{item.diasSemCompra}</td>
                            <td>{item.clientePositivo}</td>
                            <td>
                              <button className="btnAgendamento" onClick={() => {setModalObservacao(true); setClienteSelecionado(item.cliId);}}>📝</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            )}
            {/*Modal observação*/}
            {modalObservacao && (
              <div className="modalObservacao">
                <div className=" areaVizivel">
                  <div className="topBar">
                    <button className="btnFechar" onClick={() => setModalObservacao(false)}>❌</button>
                  </div>
                  <label>Motivo da ligação:</label>
                  <textarea 
                    name="observacao" 
                    className="observacao" 
                    value={ageObservacao} 
                    onChange={(e) => setAgeObsercao(e.target.value)} 
                  />
                  <button className="btnEnviar" onClick={() => semPedido()}>Enviar</button>
                </div>
              </div>
            )}
          </div>
        </>
        )}
    </>
  );
};

export default Agenda;